/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetBookingsResult } from '../../models/get-bookings-result';

export interface GetBookings$Params {
  SiteName?: string;
  PageIndex?: number;
  PageSize?: number;
}

export function getBookings(
  http: HttpClient,
  rootUrl: string,
  params?: GetBookings$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<GetBookingsResult>> {
  const rb = new RequestBuilder(rootUrl, getBookings.PATH, 'get');
  if (params) {
    rb.query('SiteName', params.SiteName, {});
    rb.query('PageIndex', params.PageIndex, {});
    rb.query('PageSize', params.PageSize, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetBookingsResult>;
    }),
  );
}

getBookings.PATH = '/Bookings';
